import * as XLSX from 'xlsx';
import { unfolder } from './CryptoMethods';
import { urlValue } from './url';
import axios from 'axios';
export const onImportExcelAsync = (file) => {
    return new Promise((resolve, reject) => {
        // Obtener el objeto del archivo cargado
        const { files } = file.target;
        // Leer el archivo a través del objeto FileReader

        const fileReader = new FileReader();
        fileReader.onload = event => {

            const { result } = event.target;
            // Leer en secuencia binaria para obtener todo el objeto de tabla de Excel
            const workbook = XLSX.read(result, { type: 'binary' });
            let data = []; // almacena los datos obtenidos
            // recorre cada hoja de trabajo para leer (aquí solo se lee la primera tabla por defecto)
            for (const sheet in workbook.Sheets) {
                if (workbook.Sheets.hasOwnProperty(sheet)) {
                    // usa el método sheet_to_json para convertir Excel a datos json
                    data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                    // break; // Si solo se toma la primera tabla, descomenta esta línea
                }
            }
            resolve(data);

            // Aquí puede lanzar una solicitud relacionada para un error de tipo de archivo incorrecto

        }
        fileReader.onerror = reject;
        // Abre el archivo en modo binario
        fileReader.readAsBinaryString(files[0]);
    })
}

export const downloadFile = (name) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    axios({
      method: 'get',
      responseType: 'blob',
      url: `${urlValue}/studio/dw-file/${name}`,
      headers: {
        'user': id,
        'access-token': token,
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }).then(function (response) {
      const data = response.data;
      var url = window.URL.createObjectURL(data);
      let tempLink = document.createElement('a');
      tempLink.href = url;
      tempLink.setAttribute('download', name);
      tempLink.click();
     
    })

  }